// 分享券弹窗
export const SHARE_COUPON_DIALOG = 'ShareCouponDialog';
// 维他奶抽奖弹窗
export const VITASOY_LOTTERY_DIALOG = 'VitasoyLotteryDialog';
